export class DocumentListPayload {
  Search: string;
  PageSize: number | null;
  PageNumber: number | null;
  SortOrder: string;
  filterBy: number;

  constructor(
    search: string = '',
    pageSize: number | null = null,
    pageNumber: number | null = null,
    sortOrder: string = '',
    filterBy: number = 2
  ) {
    this.Search = search;
    this.PageSize = pageSize;
    this.PageNumber = pageNumber;
    this.SortOrder = sortOrder;
    this.filterBy = filterBy;
  }
}
